import { cameraIcon, clearScreenIcon, flashIcon, flashOffIcon, micIcon, micOffIcon, muteIcon, redoIcon, volumeUpIcon, undoIcon } from "../../assets";
import { useEffect, useState } from "react";
import './index.css';
import SocketStore from "../../stores/SocketStore";
import strings from "../../localization";
import CallStore from "../../stores/CallStore";
import { observer } from "mobx-react";
import ScreenShotStore from "../../stores/ScreenShotStore";
import AgoraRTC from "agora-rtc-sdk-ng";

const TorchButton = ({ data }) => {
  const { icon, offIcon, text, action, isOn } = data;
  const isOnState = CallStore.isTorchOn;
  return (
    <button className="button-round button-round-medium teach-call-container-bottom-right-btn" onClick={() => {
      action(!isOnState);
    }}>

      <img src={isOnState ? icon : offIcon} alt={text} />
    </button>
  )
}



const BottomBarButton = ({ icon, offIcon, text, action, isOn }) => {
  const [isOnState, setIsOn] = useState(isOn);
  return (
    <button className="button-round button-round-medium teach-call-container-bottom-right-btn" onClick={() => {
      setIsOn(!isOnState);
      action(!isOnState);
    }}>
      <img src={isOnState ? icon : offIcon} alt={text} />
    </button>
  )
}



const TechCallContainerBottom = ({ remoteAudioTrack, remoteVideoTrack, localAudioTrackRef, remoteAudioTrackRef }) => {


  const buttons = [
    {
      id: 1,
      icon: flashIcon,
      offIcon: flashOffIcon,
      isOn: CallStore.isTorchOn,
      text: strings.flash,
      action: (state) => {
        SocketStore.sendTorch(state);
      }
    },
    {
      id: 2,
      icon: cameraIcon,
      offIcon: cameraIcon,
      isOn: true,
      text: strings.camera,
      action: (state) => {
        ScreenShotStore.takeScreenshot();
      }
    },
    {
      id: 3,
      icon: micIcon,
      offIcon: micOffIcon,
      isOn: true,
      text: strings.mic,
      action: async (state) => {
        const localAudioTrack = localAudioTrackRef.current;
        const isEnabled = localAudioTrack.enabled;
        localAudioTrack.setEnabled(!isEnabled);

        const remoteAudioTrack = remoteAudioTrackRef.current;
        const isEnabledRemote = remoteAudioTrack.isPlaying;
        if (isEnabledRemote) {
          remoteAudioTrack.stop();
        } else {
          remoteAudioTrack.play();
        }


      }
    },
    // {
    //   id: 4,
    //   icon: volumeUpIcon,
    //   offIcon: muteIcon,
    //   isOn: true,
    //   text: strings.mute,
    //   action: (state) => {
    //     const volume = remoteAudioTrack._volume;
    //     var newVolume = volume === 0 ? 100 : 0;
    //     remoteAudioTrack.setVolume(newVolume)
    //   }
    // },
  ]

  const handleClearScreen = () => {
    SocketStore.clearScreen();
  }

  return (
    <div className="teach-call-container-bottom">
      <button className="button-cta button-cta-medium" onClick={handleClearScreen}>
        <img src={clearScreenIcon} alt="clear-screen" />
        <span>{strings.clearScreen}</span>
      </button>

      <div className="teach-call-container-bottom-right">
        <TorchButton data={buttons[0]} />
        {buttons.map((button, index) =>
          button.id !== 1 && (
            <BottomBarButton key={button.id} isOn={button.isOn} icon={button.icon} offIcon={button.offIcon} text={button.text} action={button.action} />
          )
        )}
      </div>
    </div>
  );
};


export default observer(TechCallContainerBottom);